import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-animated-number',
  standalone: true,
  imports: [],
  templateUrl: './animated-number.component.html'
})
export class AnimatedNumberComponent implements OnChanges {
  @Input() targetNumber: any = 0;
  displayNumber = 0;
  private animationFrameId: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['targetNumber']) {
      this.animateNumber(0, this.targetNumber, 2000);
    }
  }


  animateNumber(start: number, end: number, duration: number) {
    const startTime = performance.now();

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      this.displayNumber = Math.floor(start + (end - start) * progress);

      if (progress < 1) {
        this.animationFrameId = requestAnimationFrame(step);
      } else {
        this.displayNumber = end;
      }
    };

    cancelAnimationFrame(this.animationFrameId);
    this.animationFrameId = requestAnimationFrame(step);
  }
}
